import { Component, OnInit } from '@angular/core';
import { blog, category } from '../shared/models/blog';
import { BlogService } from '../shared/services/blog.service';
import { Router } from '@angular/router';
import {Title } from "@angular/platform-browser";
import * as AOS from 'aos';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css']
})
export class BlogComponent implements OnInit {

  blogs: blog[];
  recentPost: blog[];
  objCategory: category[];
  searchHeading: string = "";
  selectedCategory: any = new Array();
  isSelectedTotal: number = 0;
  wait: string = "";

  constructor(
    private service: BlogService,
    public router: Router,
    private titleService: Title,
  ) { }

  async ngOnInit(): Promise<void> {
    AOS.init();
    this.titleService.setTitle("Blogs - SFI Compliance, Inc");
    this.objCategory = new Array();
    await this.service.getBlogs().then(data => {
      this.blogs = data;
      this.recentPost = data;

      this.objCategory.push({
        category: "ALL",
        total: 0,
        checked: true
      });

      const _category = this.blogs.filter(
        (thing, i, arr) => arr.findIndex(t => t.category === thing.category) === i
      );

      _category.forEach((value) => {
        this.objCategory.push({
          category: value.category,
          total: 0,
          checked: true
        });
      });

      this.blogs.forEach(element => {
        this.selectedCategory.push(element.category);
      });
    })
  }

  goToDetailsPage(id: number): void {
    this.router.navigateByUrl("/blogdetail/" + id);
  }

  goToQuestionPage(id: number): void {
    this.router.navigateByUrl("/blogquestion/" + id);
  }

  async search(): Promise<void> {
    await this.service.getBlogs().then(data => {
      //this.blogs = data;
      this.blogs = data.filter(x => x.heading.toLowerCase().toString().includes(this.searchHeading.toLowerCase()));
      console.log(this.blogs);
    })
  }

  async refresh(): Promise<void> {
    this.searchHeading = "";
    this.wait = "Please Wait while we refresh page";
    await this.search();
    this.wait = "";
  }

  async onCheckboxClick(category: string): Promise<void> {
    this.blogs = undefined;
    await this.service.getBlogDetails(0, '').then(data => {
      this.blogs = new Array();

      if (category === "ALL") {
        this.blogs = data;
      }
      else {
        data.forEach(element => {
          if (element.category === category) {
            this.blogs.push(element);
          }
        });
      }
    })

  }
}
